<template>
  <div class="core-item">
    <img
      class="core-item__icon"
      :src="src"
      :alt="label"
    >
    <h2 class="core-item__label">{{label}}</h2>
    <p class="core-item__desc">{{desc}}</p>
  </div>
</template>

<script>
export default {
  name: 'CoreItem',
  props: {
    src: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    desc: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="less" scoped>
.core-item {
  text-align: center;

  &__icon {
    width: 62px;
    height: 62px;
  }
  &__label,
  &__desc {
    margin: 0;
    line-height: 100%;
  }
  &__label {
    margin-top: 29px;
    margin-bottom: 26px;
    font-size: 24px;
    color: #333;
  }
  &__desc {
    margin: 0 auto;
    width: 224px;
    font-size: 16px;
    line-height: 30px;
    color: #6b6b6b;
  }
}
</style>
